import { AUTH_TOKEN } from 'app/constants';
import { RewardsType, RewardsTypeCreateRequest } from 'app/console-api/apps/types';
import { SuccessResponseType } from 'app/console-api';

export const getRewardsTypes = async (
  appID: string
): Promise<SuccessResponseType<RewardsType[]>> => {
  const response = await fetch(
    `${process.env.REACT_APP_TRAFFIC_EXCHANGE_CONSOLE_API_URL}/apps/${appID}/rewards`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN) || ''}`
      }
    }
  );
  if (!response.ok) {
    return Promise.reject(new Error(`Failed to get rewards types: ${response.statusText}`));
  }
  return await response.json();
};

export const createRewardsType = async (
  appID: string,
  rewardsType: RewardsTypeCreateRequest
): Promise<SuccessResponseType<RewardsType>> => {
  const response = await fetch(
    `${process.env.REACT_APP_TRAFFIC_EXCHANGE_CONSOLE_API_URL}/apps/${appID}/rewards`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN) || ''}`
      },
      body: JSON.stringify(rewardsType)
    }
  );
  if (!response.ok) {
    return Promise.reject(new Error(`Failed to create rewards type: ${response.statusText}`));
  }
  return await response.json();
};

export const updateRewardsType = async (
  appID: string,
  rewardsTypeID: number,
  rewardsType: RewardsTypeCreateRequest
): Promise<SuccessResponseType<RewardsType>> => {
  const response = await fetch(
    `${process.env.REACT_APP_TRAFFIC_EXCHANGE_CONSOLE_API_URL}/apps/${appID}/rewards/${rewardsTypeID}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN) || ''}`
      },
      body: JSON.stringify(rewardsType)
    }
  );
  if (!response.ok) {
    return Promise.reject(new Error(`Failed to update rewards type: ${response.statusText}`));
  }

  return await response.json();
};
